import VideoCategory from ".";


export const videoCategoryRoutes = () => [
  {
    path: "/admin/video-categories",
    component: VideoCategory,
    layout: "admin",
    routeType: "admin",
    title: "Videos Management",
  },
];
